import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { API_BASE } from "@/lib/api";

const SID_KEY = "tjp_sid";
const getSid = () => {
  let s = sessionStorage.getItem(SID_KEY);
  if (!s) {
    s = (crypto.randomUUID && crypto.randomUUID()) || Math.random().toString(36).slice(2) + Date.now();
    sessionStorage.setItem(SID_KEY, s);
  }
  return s;
};
const device = /iPad|Tablet/i.test(navigator.userAgent)
  ? "tablet"
  : /Mobi|Android/i.test(navigator.userAgent)
  ? "mobile"
  : "desktop";

export const track = (payload) => {
  const body = JSON.stringify({ session_id: getSid(), device, referrer: document.referrer || null, ...payload });
  try {
    navigator.sendBeacon(`${API_BASE}/track`, new Blob([body], { type: "application/json" }));
  } catch {
    fetch(`${API_BASE}/track`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  }
};

export function Tracker() {
  const location = useLocation();
  const ref = useRef({ path: null, t: 0 });

  useEffect(() => {
    const prev = ref.current;
    if (prev.path && prev.path !== location.pathname) {
      track({ event_type: "leave", path: prev.path, duration_ms: Date.now() - prev.t });
    }
    ref.current = { path: location.pathname, t: Date.now() };
    track({ event_type: "pageview", path: location.pathname });
  }, [location.pathname]);

  useEffect(() => {
    const onHide = () => {
      if (document.visibilityState === "hidden" && ref.current.path) {
        track({ event_type: "leave", path: ref.current.path, duration_ms: Date.now() - ref.current.t });
        ref.current = { ...ref.current, t: Date.now() };
      }
    };
    document.addEventListener("visibilitychange", onHide);
    return () => document.removeEventListener("visibilitychange", onHide);
  }, []);

  useEffect(() => {
    if (location.pathname !== "/") return;
    const seen = new Set();
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting && en.target.id && !seen.has(en.target.id)) {
            seen.add(en.target.id);
            track({ event_type: "section", path: "/", section: en.target.id });
          }
        });
      },
      { threshold: 0.4 }
    );
    const t = setTimeout(() => document.querySelectorAll("section[id]").forEach((s) => obs.observe(s)), 1500);
    return () => {
      clearTimeout(t);
      obs.disconnect();
    };
  }, [location.pathname]);

  return null;
}
